module.exports = __webpack_public_path__ + "img/Home.d075dadb.png";